import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _CreditProperties } from '../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectCreditPropertyGroup = ({ idSelector, onChange, label }: Props) => {

    const CreditProperties = useDataBean(_CreditProperties);
    const [lista, setLista] = useState<any[]>([]);
    const [id, setID] = useState<number>(idSelector);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
            ////console.log(idSelector)
        }
    }, [idSelector]);

    const setValue = (e: any) => {
        const selectedID = e;
        onChange(selectedID);
    };

    const getLista = () => {

        CreditProperties.instance.getCreditPropertyGroup(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }

    return (
        <>
            <label>{label ?? "Tipo de parametrica para credito:"}</label>
            <select className="form-select" value={id} onChange={(e) => setValue(e.target.value)}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.PropertyType}>
                            {item.DataBeanProperties.PropertyType}
                        </option>
                    ))
                }
            </select>
        </>
    );
};
